import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { RequestorService } from '../../../Services/Requestor.Service';
import 'react-datepicker/dist/react-datepicker.css';
import { Formik, Form, Field } from 'formik';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Loader from '../../Loader';

function TrainingStatusModal({ show, handleClose, handleSaveTrainingStatus, requestor , fetchRequestorList}) {
    const [errors, setErrors] = useState({});
    const [initialValues, setInitialValues] = useState({
        trainingCompleted: '',
        trainingDate: null,
    });

    useEffect(() => {
        const fetchTrainingDetails = async () => {
            if (show) {  
                try {
                    const trainingDetails = await RequestorService.getRequestorTrainingDetails(requestor.id);
                    const { training_completed, training_completed_date } = trainingDetails.training;
                     
                    setInitialValues({
                        trainingCompleted: training_completed ? 'Yes' : 'No',
                        trainingDate: training_completed_date ? new Date(training_completed_date) : null,
                    });
                } catch (error) {
                    console.error('Failed to fetch training details:', error);
                }
            }
        };

        fetchTrainingDetails();
    }, [show, requestor.id]);  
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values, { setSubmitting }) => {
      
        const currentErrors = {};
    
        if (!values.trainingCompleted) {
            currentErrors.trainingCompleted = 'Training status is required.';
        }
    
        if (values.trainingCompleted === 'Yes' && !values.trainingDate) {
            currentErrors.trainingDate = 'Date is required if training is completed.';
        }
    
        if (Object.keys(currentErrors).length > 0) {
            setErrors(currentErrors);
            setSubmitting(false);
            return; 
        }
    
        const trainingStatus = values.trainingCompleted === 'Yes' ? 1 : 0; // Convert to 1 or 0
        // const trainingDate = values.trainingCompleted === 'Yes' ? values.trainingDate.toISOString().split('T')[0] : null; 
        const trainingDate = values.trainingCompleted === 'Yes' ? 
        new Date(values.trainingDate.getTime() - (values.trainingDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : null;
        setLoading(true); // Show loader
        try {
            if(trainingDate!=null){ 
                await RequestorService.updateRequestorTrainingDetails(requestor.id, trainingStatus, trainingDate);
                console.log('Training details updated successfully');
                handleSaveTrainingStatus(values);  
            }
            else{
                await RequestorService.updateRequestorTrainingDetails(requestor.id, trainingStatus);
                console.log('Training details updated successfully');
                handleSaveTrainingStatus(values);  
            }

            fetchRequestorList()
        } catch (error) {
            console.error('Failed to update training details:', error);
        } finally {
            handleClose();
            setSubmitting(false);
            setErrors({});  
            setLoading(false); // Hide loader
        }
    };
    

    const handleDateChange = (date, setFieldValue) => { 
        setFieldValue('trainingDate', date); 
        if (date) {
            setErrors((prevErrors) => ({ ...prevErrors, trainingDate: undefined }));
        }
    };

    return (
        // <div className="el-deactivate-modal">
        <Modal show={show} onHide={handleClose} dialogclassname="el-deactivate-modal" backdrop="static" centered>
            <Loader loading={loading} /> 

        {/* closeButton */}
            <Modal.Header dialogclassname="el-modal-header" > 
                <Modal.Title>Training Status</Modal.Title> 
            </Modal.Header>
            <Modal.Body>
            <div className="el-super-admin">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}  
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, touched }) => (
                        <Form className='p-2'>
                            <div className='form-group p-2'>
                                <label className='p-2'><p>Has this requestor completed training?</p></label><span className="text-red">*</span>
                                <div className="d-flex ">
                                <div className="form-check mx-2 el-mb-0">
                                        <Field id={`trainingCompleted-yes`} type="radio" name="trainingCompleted" value="Yes" className="form-check-input me-2 radio-pointer"/>
                                        <label htmlFor={`trainingCompleted-yes`} className="form-check-label radio-pointer">Yes</label>
                                    </div>
                                    <div className='form-check mx-2 el-mb-0'>
                                        <Field id={`trainingCompleted-no`} type="radio" name="trainingCompleted" value="No" className="form-check-input me-2 radio-pointer" />
                                        <label htmlFor={`trainingCompleted-no`} className="form-check-label radio-pointer">No</label>
                                    </div>
                                </div>
                                {touched.trainingCompleted && errors.trainingCompleted && (
                                    <div className="text-danger">{errors.trainingCompleted}</div>
                                )}
                            </div>

                            {values.trainingCompleted === 'Yes' && (
                                <div className='form-group p-2'>
                                    <label  className='p-2'><p>Date of Training <span className="text-red">*</span></p></label><br/>
                                    <div className='mt-1'>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DateCalendar
                                                value={values.trainingDate}
                                                onChange={(date) => handleDateChange(date, setFieldValue)}
                                                maxDate={new Date()}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    {touched.trainingDate && errors.trainingDate && (
                                        <div className="text-danger mt-3">{errors.trainingDate}</div>
                                    )}
                                </div>
                            )}
                            <div className='m-2 d-flex align-items-center'>
                                <button className="el-main-button me-3"  variant="secondary" type="submit">
                                    <span>Save</span>
                                </button>
                                <button type="button" className="back-link ms-3" variant="danger" onClick={handleClose}>Close</button>
                            </div>
                        </Form>
                    )}
                </Formik>
                </div>
            </Modal.Body>
        </Modal>
        // </div>
    );
}

export default TrainingStatusModal;
